import { createContext, useContext } from 'react';

export const SearchModeContext = createContext();

export const useSearchMode = () => {
    return useContext(SearchModeContext);
};
